module.exports = __webpack_public_path__ + "static/headerRightBg375-ac0a587ed2e988af54a68ea6a907dd97.png";